import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID,
        authority: process.env.REACT_APP_AZURE_AD_AUTHORITY,
        redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin + "/auth",
        postLogoutRedirectUri: window.location.origin,
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
            piiLoggingEnabled: false,
        },
    },
};

export const loginRequest = {
    scopes: [
        "openid",
        "profile",
        "email",
        "User.Read",
    ],
};

export const tokenRequest = {
    scopes: [
        "00000003-0000-0000-c000-000000000000/.default",
    ],
    forceRefresh: false,
};
